export class Processamento {
    carteiraId: number;
    carteira: string;
    ultimaDataProcessamento: Date;
    statusProcessamento: string;
    check: boolean = false;
}
